import React, { memo } from 'react';
import { BTN_DARK_THEME, Button, CONTAINED_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
import { Container, FlexibleCol, Row } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/common/hooks';
import { ButtonLinkWrapper } from '@yme/molecules/buttons';
import { colorCoreWhite1000, colorWhiteTransparent800, FILTER_DROP_SHADOW_DEFAULT, } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { noop } from '@yme/utils/common';
import { ASPECT_RATIO_CARD_COMMON_PARAMS } from '@yme/utils/constants';
import { CardWrapperStyled, ContentStyled, SubTitleStyled } from './styled';
export function TeaserCardComponent(props) {
    const { image, title, subtitle, button, description, aspectRatioParams = ASPECT_RATIO_CARD_COMMON_PARAMS, gridSettings = {}, className, countLineVisible = 'none', onClick, } = props;
    const { isMobileView } = useWindowSize();
    return (React.createElement(CardWrapperStyled, { bgSrc: image.src, srcSet: image.srcSet, className: className, aspectRatioParams: aspectRatioParams },
        React.createElement(Container, { height: "100%" },
            React.createElement(Row, { height: "100%" },
                React.createElement(FlexibleCol, { ...(gridSettings && {
                        ...gridSettings,
                    }) },
                    React.createElement(FlexWrapper, { justifyContent: "flex-end", height: "100%", flexDirection: "column", padding: "16px 0", paddingTablet: "24px 0", paddingDesktop: "48px 0", filter: FILTER_DROP_SHADOW_DEFAULT },
                        subtitle && (React.createElement(FlexWrapper, { mb: "4px" },
                            React.createElement(SubTitleStyled, { color: colorWhiteTransparent800 }, subtitle))),
                        React.createElement(FlexWrapper, null,
                            React.createElement(HeadingLevel2, { color: colorCoreWhite1000 }, title)),
                        description && (React.createElement(FlexWrapper, { mt: "16px", mb: "16px" },
                            React.createElement(ContentStyled, { countLineVisible: countLineVisible, color: colorCoreWhite1000 }, description))),
                        button && (React.createElement(FlexWrapper, { mt: "16px" },
                            React.createElement(ButtonLinkWrapper, { buttonLink: button.link },
                                React.createElement(Button, { buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON, size: SIZE_44, label: button?.text, colorSchema: BTN_DARK_THEME, width: isMobileView ? '100%' : 'auto', onClick: onClick || noop }))))))))));
}
export const TeaserCard = memo(TeaserCardComponent);
TeaserCard.displayName = 'TeaserCard_Molecule';
